<template>
  <div>
    <PageContainer title="Consulta Carga Horária">
      <div v-if="!loaded" class="d-flex justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SpringSpinner'"
          :color="'#1C2D5A'"
          :size="80"
          class="mx-2"
        >
        </component>
      </div>

      <Box v-else class="carga-container" space="medium">
        <form @submit.prevent="handleSubmit">
          <Select
            v-if="role === '2'"
            class="input"
            :options="autoescolas"
            legend="Autoescola"
            placeholder="Autoescola"
            :modelValue="schema"
            @update:modelValue="$event => (this.schema = $event)"
            :disabled="loadingAluno || loading"
          />

          <Select
            class="input"
            :filtered="true"
            :options="alunos"
            legend="Aluno"
            placeholder="Nome do aluno"
            :modelValue="aluno"
            @update:modelValue="$event => (this.aluno = $event)"
            :disabled="loadingAluno || loading"
          />

          <Button text="Consultar" color="primary" :disabled="loadingAluno || loading">
            <Magnify :size="18" />
          </Button>
        </form>
      </Box>
    </PageContainer>

    <div v-if="loading" class="d-flex justify-content-center">
      <component
        :animation-duration="1000"
        :is="'SpringSpinner'"
        :color="'#1C2D5A'"
        :size="80"
        class="mx-2"
      >
      </component>
    </div>

    <template v-else-if="cargaHoraria.length">
      <PageContainer>
        <Box class="infos-container" space="medium">
          <h3>Carga Horária</h3>

          <CargaHorariaTeoricaTable :cargaHoraria="cargaHoraria" />
        </Box>

        <Box class="infos-container" space="medium">
          <h3>Aulas</h3>

          <Table :headers="['Agrupamento', 'Instrutor', 'Inicio', 'Fim', 'Matéria', 'Status']">
            <tr v-if="!aulasTeoricas.length">
              <td colspan="7">
                <div class="text-center">Aluno não possui aulas teóricas</div>
              </td>
            </tr>
            <tr v-else v-for="aula in aulasTeoricas" :key="aula.id_aula_teorica">
              <td>{{ aula.agrupamento }}</td>
              <td>{{ aula.instrutor.nome }}</td>
              <td>{{ utils.formatDate(aula.inicio) }}</td>
              <td>{{ utils.formatDate(aula.fim) }}</td>
              <td>{{ aula.materia.titulo }}</td>
              <td>{{ aula.status || '-' }}</td>
            </tr>
          </Table>
        </Box>
      </PageContainer>
    </template>
  </div>
</template>

<script>
import utils from '../../../services/utils'
import urlApiV2 from '@/router/urlApiV2'
import * as spinners from 'epic-spinners'
import Magnify from 'icons/Magnify'
import Box from '../../core/Box'
import Button from '../../core/Button'
import PageContainer from '../../core/PageContainer'
import Select from '../../core/Select'
import Table from '../../core/Table'
import CargaHorariaTeoricaTable from '../../teoricas/cargaHorariaTeoricaTable'

export default {
  components: {
    ...spinners,
    PageContainer,
    Box,
    Select,
    Button,
    Table,
    Magnify,
    CargaHorariaTeoricaTable,
  },
  data() {
    return {
      utils: utils,
      role: localStorage.id_role,
      autoescolas: [],
      alunos: [],
      cargaHoraria: [],
      aulasTeoricas: [],
      aluno: '',
      schema: '',
      loading: false,
      loaded: false,
      loadingAluno: false,
    }
  },
  async created() {
    switch (this.role) {
      case '1':
      case '5':
        this.schema = localStorage.schema
        break
      case '2':
        await this.buscarAutoescolas()
        this.loaded = true
        break
    }
  },
  methods: {
    async handleSubmit() {
      if (this.validateInputs()) {
        this.loading = true

        const params = {
          aluno: this.aluno,
          schema: this.schema,
        }

        await this.$http
          .get(`${urlApiV2}/aulas/teoricas/alunos/cargahoraria`, {
            params,
          })
          .then(async response => {
            this.cargaHoraria = response.body.dados

            await this.detalhes(this.aluno, this.schema)
          })
          .catch(err => {
            this.toast('Erro ao buscar carga horária, contate o suporte.')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    validateInputs() {
      if (!this.aluno) {
        this.toast('Preencha o nome do aluno.')

        return false
      }

      return true
    },
    async loadAlunos() {
      this.loadingAluno = true

      await this.$http
        .get(`${urlApiV2}/alunos/consultar/select/${this.schema}`)
        .then(response => {
          this.alunos = response.body.dados
        })
        .catch(err => {
          this.toast(err)
        })
        .finally(() => {
          this.loaded = true
          this.loadingAluno = false
        })
    },
    async buscarAutoescolas() {
      await this.$http.get(`${urlApiV2}/autoescola/todas`).then(response => {
        this.autoescolas = response.body.dados.map(autoescola => {
          const schema = autoescola.tenant_schema

          return { text: autoescola.nome_fantasia, value: schema }
        })
      })
    },
    async detalhes(idAluno, schema) {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/detalhes/${idAluno}`, {
          params: {
            schema,
          },
        })
        .then(({ body }) => {
          const dados = body.dados

          this.aulasTeoricas = dados.aulas_regulares
        })
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false,
      })
    },
  },
  watch: {
    async schema(newSchema, oldSchema) {
      await this.loadAlunos()

      this.aluno = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.carga-container {
  form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2.5rem;

    .input {
      flex: 1;
      max-width: 36.5rem;
    }
  }
}

.infos-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 32.74px;
  }
}
</style>
